var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _path, _path2, _path3, _rect30, _rect31, _rect32, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1522,
    height: 169,
    viewBox: "0 0 1522 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 87.9932,
    width: 9,
    height: 74,
    fill: "#D3E0E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 494,
    y: 87.9932,
    width: 9,
    height: 74,
    fill: "#D3E0E4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 87.9932,
    width: 9,
    height: 74,
    fill: "#D3E0E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 87.9932,
    width: 21,
    height: 7,
    fill: "#BCC9CE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 87.9932,
    width: 21,
    height: 7,
    fill: "#BCC9CE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 645,
    y: 87.9932,
    width: 21,
    height: 7,
    fill: "#BCC9CE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 79,
    width: 1522,
    height: 12,
    fill: "#D3E0E4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 42.9941,
    width: 7,
    height: 119,
    fill: "#D3E0E4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 42.9941,
    width: 8,
    height: 119,
    fill: "#D3E0E4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 42.9941,
    width: 8,
    height: 119,
    fill: "#D3E0E4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 35.1602,
    width: 69,
    height: 133.609,
    fill: "#D3E0E4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 14.9941,
    width: 5,
    height: 20,
    fill: "#D3E0E4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14.9941,
    width: 5,
    height: 20,
    fill: "#D3E0E4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 14.9941,
    width: 5,
    height: 20,
    fill: "#D3E0E4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 14.9941,
    width: 5,
    height: 20,
    fill: "#D3E0E4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 14.9941,
    width: 5,
    height: 20,
    fill: "#D3E0E4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 14.9941,
    width: 5,
    height: 20,
    fill: "#D3E0E4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 14.9941,
    width: 5,
    height: 20,
    fill: "#D3E0E4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 14.9941,
    width: 5,
    height: 20,
    fill: "#D3E0E4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 14.9941,
    width: 5,
    height: 20,
    fill: "#D3E0E4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 14.9941,
    width: 5,
    height: 20,
    fill: "#D3E0E4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    y: 35.1602,
    width: 158,
    height: 18.0825,
    fill: "#D3E0E4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    y: 36.165,
    width: 158,
    height: 3.01375,
    fill: "#02C27F"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 52.2383,
    width: 58,
    height: 37.1695,
    fill: "#A6BEC5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 53.2432,
    width: 57,
    height: 35.1604,
    fill: "#A9CEDA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 91.417,
    width: 25,
    height: 40.1833,
    fill: "#A6BEC5"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 92.4219,
    width: 25,
    height: 38.1741,
    fill: "#A9CEDA"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 91.417,
    width: 27,
    height: 40.1833,
    fill: "#A6BEC5"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 92.4219,
    width: 25,
    height: 38.1741,
    fill: "#A9CEDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 49.9941V84.9941M22.5 49.9941V84.9941M30.5 49.9941V84.9941M38.5 49.9941V84.9941M46.5 49.9941V84.9941M54.5 49.9941V84.9941M62 50.4941L9 50.4941M62 58.4941L9 58.4941M62 66.4941H9M62 74.4941H9M62 82.4941H9",
    stroke: "#73B1C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 88.9941V126.994M59.5 88.9941V126.994M67.5 88.9941V126.994M47 96.4941H72M47 104.494H72M47 112.494H72M47 120.494H72",
    stroke: "#73B1C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 88.9941V126.994M17.5 88.9941V126.994M25.5 88.9941V126.994M5 96.4941H30M5 104.494H30M5 112.494H30M5 120.494H30",
    stroke: "#73B1C6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 94.9941,
    width: 15,
    height: 6,
    fill: "#517A70"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 110.994,
    width: 15,
    height: 6,
    fill: "#517A70"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 18.0825,
    fill: "#D3E0E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.432 11V6.53H41.212L42.886 8.804H42.514L44.152 6.53H44.932V11H44.11V7.46L44.428 7.538L42.73 9.8H42.634L40.978 7.538L41.248 7.46V11H40.432ZM46.0215 11L47.5635 6.53H48.6195L50.1615 11H49.2735L48.9555 10.04H47.2275L46.9035 11H46.0215ZM47.4615 9.32H48.7215L47.9775 7.094H48.2055L47.4615 9.32ZM51.259 11V6.53H52.921C53.225 6.53 53.493 6.586 53.725 6.698C53.961 6.806 54.145 6.966 54.277 7.178C54.409 7.386 54.475 7.64 54.475 7.94C54.475 8.248 54.401 8.51 54.253 8.726C54.109 8.942 53.913 9.102 53.665 9.206L54.691 11H53.767L52.669 9.038L53.197 9.35H52.075V11H51.259ZM52.075 8.63H52.933C53.081 8.63 53.209 8.602 53.317 8.546C53.425 8.486 53.509 8.404 53.569 8.3C53.629 8.196 53.659 8.076 53.659 7.94C53.659 7.8 53.629 7.68 53.569 7.58C53.509 7.476 53.425 7.396 53.317 7.34C53.209 7.28 53.081 7.25 52.933 7.25H52.075V8.63ZM55.8258 11V6.53H56.6418V11H55.8258ZM58.1015 11V6.53H58.7375L61.1975 9.842L60.8675 9.908V6.53H61.6835V11H61.0415L58.6175 7.664L58.9175 7.598V11H58.1015ZM62.7828 11L64.3248 6.53H65.3808L66.9228 11H66.0348L65.7168 10.04H63.9888L63.6648 11H62.7828ZM64.2228 9.32H65.4828L64.7388 7.094H64.9668L64.2228 9.32ZM70.4787 11V7.25H69.3207V6.53H72.4407V7.25H71.3007V11H70.4787ZM73.5386 11V6.53H75.2006C75.5046 6.53 75.7726 6.586 76.0046 6.698C76.2406 6.806 76.4246 6.966 76.5566 7.178C76.6886 7.386 76.7546 7.64 76.7546 7.94C76.7546 8.248 76.6806 8.51 76.5326 8.726C76.3886 8.942 76.1926 9.102 75.9446 9.206L76.9706 11H76.0466L74.9486 9.038L75.4766 9.35H74.3546V11H73.5386ZM74.3546 8.63H75.2126C75.3606 8.63 75.4886 8.602 75.5966 8.546C75.7046 8.486 75.7886 8.404 75.8486 8.3C75.9086 8.196 75.9386 8.076 75.9386 7.94C75.9386 7.8 75.9086 7.68 75.8486 7.58C75.7886 7.476 75.7046 7.396 75.5966 7.34C75.4886 7.28 75.3606 7.25 75.2126 7.25H74.3546V8.63ZM77.7394 11L79.2814 6.53H80.3374L81.8794 11H80.9914L80.6734 10.04H78.9454L78.6214 11H77.7394ZM79.1794 9.32H80.4394L79.6954 7.094H79.9234L79.1794 9.32ZM82.9769 11V6.53H83.7929V11H82.9769ZM85.2527 11V6.53H85.8887L88.3487 9.842L88.0187 9.908V6.53H88.8347V11H88.1927L85.7687 7.664L86.0687 7.598V11H85.2527ZM93.5624 11.072C93.2784 11.072 93.0144 11.02 92.7704 10.916C92.5304 10.812 92.3224 10.668 92.1464 10.484C91.9744 10.296 91.8484 10.078 91.7684 9.83L92.4464 9.536C92.5544 9.792 92.7104 9.994 92.9144 10.142C93.1184 10.286 93.3484 10.358 93.6044 10.358C93.7484 10.358 93.8724 10.336 93.9764 10.292C94.0844 10.244 94.1664 10.18 94.2224 10.1C94.2824 10.02 94.3124 9.924 94.3124 9.812C94.3124 9.68 94.2724 9.572 94.1924 9.488C94.1164 9.4 94.0004 9.332 93.8444 9.284L92.9864 9.008C92.6384 8.9 92.3764 8.738 92.2004 8.522C92.0244 8.306 91.9364 8.052 91.9364 7.76C91.9364 7.504 91.9984 7.278 92.1224 7.082C92.2504 6.886 92.4264 6.734 92.6504 6.626C92.8784 6.514 93.1384 6.458 93.4304 6.458C93.6984 6.458 93.9444 6.506 94.1684 6.602C94.3924 6.694 94.5844 6.824 94.7444 6.992C94.9084 7.156 95.0304 7.35 95.1104 7.574L94.4384 7.874C94.3504 7.65 94.2184 7.478 94.0424 7.358C93.8664 7.234 93.6624 7.172 93.4304 7.172C93.2944 7.172 93.1744 7.196 93.0704 7.244C92.9664 7.288 92.8844 7.352 92.8244 7.436C92.7684 7.516 92.7404 7.612 92.7404 7.724C92.7404 7.848 92.7804 7.958 92.8604 8.054C92.9404 8.146 93.0624 8.218 93.2264 8.27L94.0484 8.528C94.4044 8.644 94.6704 8.804 94.8464 9.008C95.0264 9.212 95.1164 9.464 95.1164 9.764C95.1164 10.02 95.0504 10.246 94.9184 10.442C94.7864 10.638 94.6044 10.792 94.3724 10.904C94.1404 11.016 93.8704 11.072 93.5624 11.072ZM97.2431 11V7.25H96.0851V6.53H99.2051V7.25H98.0651V11H97.2431ZM99.6383 11L101.18 6.53H102.236L103.778 11H102.89L102.572 10.04H100.844L100.52 11H99.6383ZM101.078 9.32H102.338L101.594 7.094H101.822L101.078 9.32ZM105.369 11V7.25H104.211V6.53H107.331V7.25H106.191V11H105.369ZM108.429 11V6.53H109.245V11H108.429ZM112.907 11.072C112.579 11.072 112.273 11.014 111.989 10.898C111.705 10.782 111.457 10.62 111.245 10.412C111.033 10.204 110.867 9.96 110.747 9.68C110.631 9.396 110.573 9.09 110.573 8.762C110.573 8.43 110.631 8.124 110.747 7.844C110.863 7.564 111.027 7.32 111.239 7.112C111.451 6.904 111.699 6.744 111.983 6.632C112.267 6.516 112.575 6.458 112.907 6.458C113.239 6.458 113.547 6.516 113.831 6.632C114.115 6.748 114.363 6.91 114.575 7.118C114.787 7.322 114.951 7.564 115.067 7.844C115.187 8.124 115.247 8.43 115.247 8.762C115.247 9.09 115.187 9.396 115.067 9.68C114.947 9.96 114.781 10.204 114.569 10.412C114.357 10.62 114.109 10.782 113.825 10.898C113.545 11.014 113.239 11.072 112.907 11.072ZM112.907 10.328C113.127 10.328 113.329 10.29 113.513 10.214C113.697 10.134 113.857 10.024 113.993 9.884C114.133 9.744 114.239 9.578 114.311 9.386C114.387 9.194 114.425 8.986 114.425 8.762C114.425 8.538 114.387 8.332 114.311 8.144C114.239 7.952 114.133 7.786 113.993 7.646C113.857 7.502 113.697 7.392 113.513 7.316C113.329 7.24 113.127 7.202 112.907 7.202C112.691 7.202 112.491 7.24 112.307 7.316C112.123 7.392 111.961 7.502 111.821 7.646C111.685 7.786 111.579 7.952 111.503 8.144C111.427 8.332 111.389 8.538 111.389 8.762C111.389 8.986 111.427 9.194 111.503 9.386C111.579 9.578 111.685 9.744 111.821 9.884C111.961 10.024 112.123 10.134 112.307 10.214C112.491 10.29 112.691 10.328 112.907 10.328ZM116.572 11V6.53H117.208L119.668 9.842L119.338 9.908V6.53H120.154V11H119.512L117.088 7.664L117.388 7.598V11H116.572Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainStation);
export default __webpack_public_path__ + "static/media/train__station.9b37d3d5a4bee970212c6a3db563947e.svg";
export { ForwardRef as ReactComponent };